var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfluence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41652 30.9091C6.08547 31.4927 5.64407 32.1293 5.31302 32.6599C4.98197 33.1374 5.14749 33.774 5.69924 34.0923L12.872 38.3367C13.4237 38.655 14.0859 38.4958 14.4169 37.9653C14.6928 37.4878 15.079 36.9042 15.4652 36.2676C18.3343 31.758 21.1483 32.2885 26.3347 34.6759L33.4523 37.9122C34.0041 38.1775 34.6662 37.9122 34.942 37.3817L38.3629 29.9541C38.5836 29.4236 38.3629 28.7869 37.8111 28.5747C36.3214 27.885 33.3419 26.5587 30.6384 25.2854C20.9276 20.8288 12.7065 21.0941 6.41652 30.9091Z",
    fill: "url(#paint0_linear_12115_71440)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5835 14.0909C38.9145 13.5073 39.3559 12.8707 39.687 12.3401C40.018 11.8626 39.8525 11.226 39.3008 10.9077L32.128 6.66333C31.5763 6.345 30.9142 6.50417 30.5831 7.03471C30.3072 7.51219 29.921 8.09579 29.5348 8.73244C26.6657 13.242 23.8517 12.7115 18.6653 10.3241L11.6029 7.03471C11.0511 6.76944 10.389 7.03471 10.1132 7.56525L6.6923 14.9928C6.4716 15.5234 6.6923 16.16 7.24405 16.3722C8.73378 17.0619 11.7132 18.3883 14.4168 19.6616C24.0725 24.1712 32.2935 23.9059 38.5835 14.0909Z",
    fill: "url(#paint1_linear_12115_71440)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12115_71440",
    x1: 39.5287,
    y1: 42.5825,
    x2: 12.0972,
    y2: 34.0456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9182,
    stopColor: "#2380FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12115_71440",
    x1: 6.89662,
    y1: 4.45559,
    x2: 28.167,
    y2: 17.1667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9182,
    stopColor: "#2380FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfluence);
export default __webpack_public_path__ + "static/media/confluence.cbb2687c085544125ed424b4166b3a65.svg";
export { ForwardRef as ReactComponent };